export default __webpack_public_path__ + "static/media/man_mittel_hinten.4dfa548a.jpg";